import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { DATE_YMD, IS_NOT_NULL_OR_UNDEFINED, IS_NULL_OR_UNDEFINED } from 'cargo-chief-commons';

@Component({
	selector: 'app-carrier-rate-dialog',
	templateUrl: './carrier-rate-dialog.component.html',
	styleUrls: ['./carrier-rate-dialog.component.scss'],
})
export class CarrierRateDialogComponent implements OnInit {
	hasRate: boolean = false;
	carrierProvidingRate: boolean = false;
	title: string;

	rateDetails: UntypedFormGroup;
	carrierRespondedAt = new UntypedFormControl(new Date());

	isCarrierProvidingRate: boolean = false;
	expirationDate = new UntypedFormControl();
	rateInputLabel: string = 'Carrier Rate';
	submitButtonLabel: string = 'Add Rate';
	minExpirationDate = new Date();
	isFormSubmitted: boolean = false;
	IS_NULL_OR_UNDEFINED = IS_NULL_OR_UNDEFINED;
	carrierRateDetails: UntypedFormGroup;
	specifyDays: boolean = false;

	constructor(
		public dialogRef: MatDialogRef<CarrierRateDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: CarrierRate,
		private formBuilder: UntypedFormBuilder
	) {}

	ngOnInit() {
		this.rateDetails = this.formBuilder.group({
			desiredPrice: ['', Validators.required],
			carrierRespondedAt: '',
		});
		this.hasRate = this.data.hasRate;
		this.title = this.data.title;

		if (this.data.isCarrierProvidingRate) {
			this.isCarrierProvidingRate = this.data.isCarrierProvidingRate;
			if (this.data.expirationDate) {
				this.expirationDate = new UntypedFormControl(new Date(this.data.expirationDate));
			}
			if (this.data.rate) {
				this.rateDetails.get('desiredPrice').setValue(this.data.rate);
			}
		}
		if (this.data.rateInputLabel) {
			this.rateInputLabel = this.data.rateInputLabel;
		}
		if (this.data.submitButtonLabel) {
			this.submitButtonLabel = this.data.submitButtonLabel;
		}

		if (this.isCarrierProvidingRate) {
			this.setCarrierRateForm();
		}
		if (this.data.carrierProvidingRate) {
			this.carrierProvidingRate = this.data.carrierProvidingRate;
		}
	}

	setCarrierRateForm() {
		this.carrierRateDetails = this.formBuilder.group({
			monday: [false],
			tuesday: [false],
			wednesday: [false],
			thursday: [false],
			friday: [false],
			saturday: [false],
			sunday: [false],
			loadVolume: null,
			loadVolumeDuration: 'Week',
		});
	}

	addRate() {
		this.isFormSubmitted = true;
		this.rateDetails.patchValue({
			carrierRespondedAt: DATE_YMD(this.carrierRespondedAt.value),
		});
		let payload = Object.assign({}, this.rateDetails.value);
		payload.desiredPrice = Number(payload.desiredPrice) * 100;
		payload['carrierProvidingRate'] = this.carrierProvidingRate;
		if (this.isCarrierProvidingRate) {
			payload = { ...payload, ...this.carrierRateDetails.value };
			if (payload.loadVolume) {
				payload.loadVolume = +payload.loadVolume;
			} else {
				payload.loadVolumeDuration = null;
			}
			if (IS_NOT_NULL_OR_UNDEFINED(this.expirationDate.value)) {
				payload['expirationDate'] = DATE_YMD(this.expirationDate.value);
			}
		}
		this.closeDialog(payload);
	}

	setSpecifyDays() {
		this.specifyDays = !this.specifyDays;
		this.carrierRateDetails.get('monday').setValue(false);
		this.carrierRateDetails.get('tuesday').setValue(false);
		this.carrierRateDetails.get('wednesday').setValue(false);
		this.carrierRateDetails.get('thursday').setValue(false);
		this.carrierRateDetails.get('friday').setValue(false);
		this.carrierRateDetails.get('saturday').setValue(false);
		this.carrierRateDetails.get('sunday').setValue(false);
	}

	closeDialog(data: { desiredPrice: number; carrierRespondedAt: string } | null): void {
		this.dialogRef.close(data);
	}
}

interface CarrierRate {
	hasRate: boolean;
	title: string;
	isCarrierProvidingRate?: boolean;
	rate?: number;
	expirationDate?: Date;
	showExpirationDate?: boolean;
	rateInputLabel?: string;
	submitButtonLabel?: string;
	carrierProvidingRate?: boolean;
}
